import { render } from "./RgpdFilter.vue?vue&type=template&id=20b2905a"
import script from "./RgpdFilter.vue?vue&type=script&lang=js"
export * from "./RgpdFilter.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__